import styled, { css } from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { NumberInput } from '@dreryk/react-components';

import { timeSlotsTranslationKeys } from '../../../../../translations';
import { AvailabilityFormController } from '../../../common.types';
import { TIME_SLOT_OTHER } from '../AvailabilityTimeSlotFixed/AvailabilityTimeSlotFixed.types';

import { MANUAL_DURATION_STEP, MAX_MANUAL_DURATION, MIN_MANUAL_DURATION } from './AvailabilityTimeSlotManual.types';
import { StyledAvailabilityTimeSlotManualDuration } from './StyledAvailabilityTimeSlotManualDuration';

const AvailabilityTimeSlotNumberInput = styled(NumberInput)<{ $withError: boolean }>`
   ${(props) =>
      props.$withError &&
      css`
         input {
            border: 2px solid ${props.theme.error};
            color: ${props.theme.error};
         }
      `}
`;
AvailabilityTimeSlotNumberInput.displayName = 'AvailabilityTimeSlotNumberInput';

type AvailabilityTimeSlotManualProps = {
   readonly register: AvailabilityFormController['register'];
   readonly watch: AvailabilityFormController['watch'];
   readonly formState: AvailabilityFormController['formState'];
};

export const slotDurationFixedFieldVisible = (watch: AvailabilityFormController['watch']): boolean => {
   const slotDuration = watch('slotDurationFixed');
   return TIME_SLOT_OTHER === slotDuration;
};

export const AvailabilityTimeSlotManual = (props: AvailabilityTimeSlotManualProps): JSX.Element => {
   return (
      <StyledAvailabilityTimeSlotManualDuration>
         {slotDurationFixedFieldVisible(props.watch) ? (
            <>
               <AvailabilityTimeSlotNumberInput
                  controller={props.register('slotDurationManual', {
                     min: undefined,
                     max: undefined,
                  })}
                  min={MIN_MANUAL_DURATION}
                  max={MAX_MANUAL_DURATION}
                  stepValue={MANUAL_DURATION_STEP}
                  $withError={Boolean(props.formState.errors.slotValidation)}
                  testId={'manualDuration'}
               />
               <Translate>{timeSlotsTranslationKeys.minutesAbbreviation}</Translate>
            </>
         ) : null}
      </StyledAvailabilityTimeSlotManualDuration>
   );
};
